import { render, staticRenderFns } from "./vehicleList.vue?vue&type=template&id=23c80bbf"
import script from "./vehicleList.vue?vue&type=script&lang=js"
export * from "./vehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports